import request from '@/utils/request'

const base = "/internal-auth";
const scrmBase = "/scrm";
//获取钉钉authCode后登录
export function realLogin(authCode) {
  let headers ={
    Authorization:authCode,
    'login-type':'ding_ding',
  };
  if(process.env.NODE_ENV != "production" && process.env.VUE_APP_BUILD != '1'){
    headers['X-Forwarded-Host'] = 'scrm.dev.com';
  }
  return request({
    url: `${base}/login`,
    method: 'post',
    headers:{
      ...headers
    },
  })
}

export function userInfo(data) {
  return request({
    // url: '/login.json',
    url: `${base}/getUserInfoByToken`,
    method: 'post',
    data: data
  })
}

export function getVerificationCode() {
  return request({
    url: '/security/obtain-graph-captcha',
    method: 'get'
  })
}

export function login (data) {
  return request({
    url: '/login.json',
    // url: '/login/username_password',
    method: 'post',
    data: data
  })
}

export function getMenu(data) {
  return request({
    // url: '/menu.json',
    url: `${base}/menu/queryAccessibleMenus`,
    method: 'post',
    data
  })
}

/** 获取验证码
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/53/interface/api/6877
 */
export function getCaptcha(params) {
  return request({
    url: `${base}/obtain-graph-captcha`,
    method: 'get',
    params
  })
}

/** 账号密码登陆
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/53/interface/api/6876
 */
export function accountLogin(params) {
  let headers = {};
  if (process.env.NODE_ENV != "production" && process.env.VUE_APP_BUILD != '1') {
    headers['X-Forwarded-Host'] = 'scrm.dev.com';
  }
  return request({
    url: `${base}/login`,
    //url: '/login.json',
    method: 'post',
    headers: {
      ...params,
      ...headers,
      isWithoutToken: true
    },
  })
}

/** 重置密码
 *	@param { Object } data
 */
export function changePassword(data) {
  return request({
    url: `${base}/member/changePassword`,
    method: 'post',
    data
  })
}

/** 修改密码
 * @param { string } password
 * @param { string } oldPassword
 */
export function newChangePassword(data) {
  return request({
    url: `${scrmBase}/user/updatePassword`,
    method: 'post',
    data
  })
}

